<template>
  <div class="text">
    <h2 class="title">{{ producto.nombreProducto }}</h2>
    <div class="wysiwyg">
      <ul class="lista">
        <li v-for="garantia in garantiasOrdenadas" :key="garantia.idGarantia">
          {{ garantia.descGarantia }}
          <SelectGarantia
            :items="garantia.items"
            :productoId="producto.id"
            :garantia="garantia"
            v-if="!show"
          />
          <ShowCoberturaSeleccionada
            :items="garantia.items"
            :garantia="garantia"
            v-if="show"
          />
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    producto: {
      type: Object,
      required: true
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    garantiasOrdenadas() {
      return Object.values(this.producto.garantias).sort(
        (g1, g2) => g1.orden - g2.orden
      );
    }
  }
};
</script>
<style lang="scss" scoped>
.title {
  margin-bottom: 0.8em;
  font-size: 2.4rem;
  color: #16304f;
  font-weight: 350;
}

.lista {
  list-style-type: square;
  margin-left: 2.5rem;
  margin-bottom: 0.5rem;
  font-size: 1.7rem;
  li {
    margin: 0.2rem;
  }
}
</style>
